import { render } from "./AdditionalNotes.vue?vue&type=template&id=293af50e"
import script from "./AdditionalNotes.vue?vue&type=script&lang=js"
export * from "./AdditionalNotes.vue?vue&type=script&lang=js"

import "./AdditionalNotes.vue?vue&type=style&index=0&id=293af50e&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/AdditionalNotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "293af50e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('293af50e', __exports__)) {
    console.log('reload')
    api.reload('293af50e', __exports__)
  }
  
  module.hot.accept("./AdditionalNotes.vue?vue&type=template&id=293af50e", () => {
    console.log('re-render')
    api.rerender('293af50e', render)
  })

}


export default __exports__